import React from "react";
import BoundedInput from "../../../../InputForm/BoundedForm";

class InvestmentProjectGrantFormComponent extends React.Component {
  render() {
    const ids = {
      id: "ppi-grant-id",
      name: "ppi-grant-name",
    };

    return (
      <form onSubmit={this.props.onSubmit}>
        {this.props.delete ? (
          <div>
            Êtes-vous sûr de vouloir supprimer la subvention{" "}
            <strong>{this.props.grant.name}</strong> ?
          </div>
        ) : this.props.toggle ? (
          <div>
            Êtes-vous sûr de vouloir{" "}
            {this.props.grant.awarded ? "annuler" : "octroyer"} la subvention{" "}
            <strong>{this.props.grant.name}</strong> ?
          </div>
        ) : (
          <div className="columns is-desktop">
            <div className="column">
              <p className="field is-horizontal">
                <span className="field-label is-normal">
                  <label className="label" htmlFor={ids.user}>
                    Intitulé de la subvention
                  </label>
                </span>
                <span className="field-body">
                  <span className="field has-addons has-addons-right">
                    <span
                      className={`select is-fullwidth ${
                        this.props.submitting ? "is-loading" : ""
                      }`}
                    >
                      <select
                        disabled={this.props.submitting}
                        id={ids.id}
                        name="id"
                        onChange={this.props.onIdChange}
                        value={this.props.id}
                        required
                      >
                        <option value="">Sélectionnez une subvention</option>
                        {this.props.grants.map((grant) => (
                          <option value={grant.id}>{grant.name}</option>
                        ))}
                        <option value="-2">
                          La subvention n'est pas dans la liste
                        </option>
                      </select>
                    </span>
                  </span>
                </span>
              </p>
              {this.props.id == "-2" ? (
                <p className="field is-horizontal">
                  <span className="field-label is-normal">
                    <label className="label" htmlFor={ids.name}>
                      Nom de la subvention
                    </label>
                  </span>
                  <span className="field-body">
                    <span className="field">
                      <span className="control">
                        <BoundedInput
                          className="input"
                          id={ids.name}
                          name="name"
                          type="text"
                          min="0"
                          max="30"
                          onChange={this.props.onNameChange}
                          placeholder="Nom de la subvention"
                          value={this.props.name}
                          recommendedMax="30"
                          required
                        />
                        {/* <input
																className   = "input"
																id          = {ids.name}
																name        = "name"
																onChange    = {this.props.onNameChange}
																placeholder = "Nom de la subvention"
																type        = "text"
																value       = {this.props.name}
																required /> */}
                      </span>
                    </span>
                  </span>
                </p>
              ) : null}
            </div>
          </div>
        )}
        <div className="columns">
          {/* !this.props.submitting
						? <div className="column">
								<button className={`button is-secondary ${this.props.submitting ? "is-loading" : ""}`}>
									Annuler
								</button>
							</div>
						: null
					*/}
          <div className="column">
            <button
              className={`button is-primary ${
                this.props.submitting ? "is-loading" : ""
              }`}
            >
              {this.props.delete
                ? "Supprimer"
                : this.props.grant
                ? "Modifier"
                : "Ajouter"}{" "}
              la subvention
            </button>
          </div>
        </div>
      </form>
    );
  }
}

export default InvestmentProjectGrantFormComponent;



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/investments/grants/form-component.js